<template>
  <div id="tabBar">
    <div class="bar">
      <div class="logo">
        <a href="https://dict.youdao.com/?keyfrom=dict2.index">
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/YDlogo.png" alt="" srcset="">
        </a>
        <h5>有道服务条款</h5>
      </div>
      <div class="other_products">
        <a href="https://www.youdao.com/?keyfrom=fanyi-new.copyright" target="_blank">有道首页</a>
        <a href="http://shared.youdao.com/www/about.html?keyfrom=dict2.index" target="_blank">更多产品</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  props: {
    msg: String
  }
}
</script>

<style scoped>
#tabBar {
  width: 100%;
  height: 72px;
  background: rgba(255,255,255,1);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.04);
}
.bar {
  max-width: 1440px;
  min-width: 1106px;
  height: 72px;
  margin: 0 auto;
}
.bar h5 {
  height: 72px;
  font-size: 16px;
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color: rgba(89,87,87,1);
  line-height: 72px;
  float: left;
}

.logo {
  float: left;
}
.logo img {
  width: 134px;
  height: 30px;
  display: inline-block;
  margin: 21px 20px 21px 40px;
  float: left;
}
.other_products {
  float: right;
  height: 72px;
  font-size:12px;
  font-family: PingFangSC-Semibold;
  font-weight: bold;
  color:rgba(51,51,51,1);
  line-height: 72px;
  margin-right: 40px;
}
.other_products a {
  display: inline-block;
  font-style: normal;
  margin-right: 36px;
}
.other_products a:last-child {
  margin-right: 0;
}
</style>
